// This file is auto-generated by config.firebase.cjs.
// Do not edit this file manually.

export const config = {
	production: true,
	label: "TEST/QA",
	name: "@santashop/app",
	version: "2026.09.0-beta.10",
	appCheckKey: "6LfQqwkpAAAAAHyIhwZ4v9ZGl6lMdwzsh_maGnSU",
	appCheckEnabled: true,
	programYear: 2026,
	shopDays: [12,13,15,16],
	emulatorPorts: {
		auth: 9099,
		functions: 5001,
		firestore: 8080,
		storage: 9199,
	},
};
